import React, { useState, useEffect } from "react";
import GTCCreateGeoChannel from "../components/GTCCreateGeoChannel";
import GTCLinearProgress from "../components/GTCLinearProgress";
import { apiRequest, API_CONSTANTS } from "../libs/apiRequest";
import { useDispatch } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import '../css/gtc-service.css';
import '../css/shared-components.css';
import { FaGlobeAmericas, FaPlus } from 'react-icons/fa';

function GTCService() {
    const [openCreateChan, setOpenCreateChan] = useState(false);
    const [progress, setProgress] = useState(10);
    const [channels, setChannels] = useState<any[]>([]);
    const dispatch = useDispatch();
    const navigate = useNavigate();   
    const { service } = useParams(); 


    const getPlanDetails = async (plan: string) => {
        // subscriptionplandetails
        try {
            const data = await apiRequest({
                method: "GET",
                fn: "subscriptionplandetails",
                api: API_CONSTANTS.PRIVATE_API,
                data: {
                    plan: plan,
                    service: service
                }
            });
            if (data && data.status == 200) {
                const apiData = data.data;
                return apiData;
            }
            return null;
        } catch (error) {
            console.log("getSubsciptionDetails", error)
            return null;
        }
    }

    const getChannels = async () => {
        try {
            const res = await apiRequest({
                method: "GET",
                api: API_CONSTANTS.PRIVATE_API,
                fn: "geochan",
                data: {
                    service: service
                }
            })
            if (res && res.status == 200) {
                const chans = await Promise.all((res?.chan || []).map(async (chan :any) => {
                    const plan = chan.plan;
                    const planData = await getPlanDetails(plan.plan)
                    chan.plan = planData
                    return chan;
                }))
                // console.log("getChannels", chans)
                setChannels(chans)
            }
        } catch (error) {
            console.log("getChannels", error)
        }
    }

    useEffect(() => {
        getChannels();
    }, [])

    let serviceName = "Unknown";
    if (service == "rgeo") {
        serviceName = "Reverse Geocoding";
    }
    else if (service == "geo") {
        serviceName = "IP Geolocation";
    }
    
    return (
        <div className='service-dashboard'>
            <div className="page-header">
                <div className="header-title-section">
                    <h1>{serviceName} Service</h1>
                    <p>Manage your geolocation channels and monitor usage</p>
                </div>
            </div>

            <div className="service-content">
                <div className="channels-grid">
                    {channels.map((chan: any, i) => (
                        <div key={i} className="channel-card">
                            <div className="channel-header">
                                <h2>{chan.name || ""}</h2>
                                <button 
                                    className="settings-button"
                                    onClick={() => navigate(`/service/${service}/channel/${chan.chan}`)}
                                >
                                    Settings
                                </button>
                            </div>
                            
                            <div className="usage-section">
                                <h3>Usage Statistics</h3>
                                <div className="progress-wrapper">
                                    <GTCLinearProgress progress={(chan.ctr / chan.limit) * 100}/>
                                </div>
                            </div>

                            <div className="channel-stats">
                                <div className="stat-item">
                                    <label>Requests</label>
                                    <span className="stat-value">{chan.ctr}</span>
                                </div>
                                <div className="stat-item">
                                    <label>Limit</label>
                                    <span className="stat-value">{chan.limit}</span>
                                </div>
                                <div className="stat-item">
                                    <label>Subscription</label>
                                    <span className="stat-value">{chan.plan.plan.title}</span>
                                </div>
                            </div>
                        </div>
                    ))}

                    <div className="create-channel-card" onClick={() => setOpenCreateChan(true)}>
                        <div className="create-content">
                            <FaPlus className="plus-icon" />
                            <span>Create New Channel</span>
                        </div>
                    </div>
                </div>
            </div>
            
            <GTCCreateGeoChannel show={openCreateChan} close={() => setOpenCreateChan(false)}/>
        </div>
    );
}

export default GTCService;